import { render, staticRenderFns } from "./V2Button.vue?vue&type=template&id=3490ecbe&scoped=true&"
import script from "./V2Button.vue?vue&type=script&lang=js&"
export * from "./V2Button.vue?vue&type=script&lang=js&"
import style0 from "./V2Button.vue?vue&type=style&index=0&id=3490ecbe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3490ecbe",
  null
  
)

export default component.exports